// extracted by mini-css-extract-plugin
module.exports = {"card":"components-TasteCard2-TasteCard2__card--3IfNM"};